import { render, staticRenderFns } from "./RqtaEditAppr.vue?vue&type=template&id=1c933efb&scoped=true&"
import script from "./RqtaEditAppr.vue?vue&type=script&lang=js&"
export * from "./RqtaEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c933efb",
  null
  
)

export default component.exports